import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';

import { IconComponent } from '@shared/icon/icon.component';
import { CollectionCardMiniModule } from '../collection-card-mini/collection-card-mini.module';
import { PrivateContentInformerComponent } from './private-content-informer.component';

@NgModule({
  declarations: [PrivateContentInformerComponent],
  exports: [PrivateContentInformerComponent],
  imports: [LocaleSharedModule, CommonModule, IconComponent, CollectionCardMiniModule, ScrollingModule],
})
export class PrivateContentInformerModule {}
